import React, { useEffect, useState } from "react";
import { PieChart, Pie, Cell, Tooltip } from "recharts";
import { useTranslation } from "react-i18next";
import { useThemeContext } from "../../../Context/ThemeContext";
import { DARKCOLORS, LIGHTCOLORS } from "../../../Utils/constants";
// NOTE: this service function does not exist yet — add it to authService.js
// with the same signature style as getSalesByDiscountCoupons, returning
// { bowlsCashbackAmount, cupsCashbackAmount } for the given filters.
import { getCashbackOverview } from "../../../Services/authService";

const CashbackOverviewChart = ({ selectedLocations, dateRange, applyClicked }) => {
  const { t, i18n } = useTranslation();
  const { mode } = useThemeContext();

  // Bowls = purple, Cups = green — matches the Returns by Location bar colors
 const colorMapping = {
  Bottles: "#6BE675",
  Bowls:"#4C33DB"
};

  const grayscaleColor = mode === "light" ? LIGHTCOLORS.GreyScale30 : DARKCOLORS.GreyScale30;
  const dividerColor = mode === "light" ? LIGHTCOLORS.GreyScale30 : DARKCOLORS.GreyScale30;

  const [data, setData] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const hasData = data.length > 0 && data.some((d) => d.value > 0);
  const chartData = hasData ? data : [{ name: "", value: 1, color: grayscaleColor }];

  useEffect(() => {
    const fetchData = async () => {
      setError(null);
      try {
        const formatLocalDate = (date) => {
          if (!date) return null;
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const day = String(date.getDate()).padStart(2, "0");
          return `${year}-${month}-${day}`;
        };

        const startDate = dateRange[0]?.startDate ? formatLocalDate(new Date(dateRange[0].startDate)) : null;
        const endDate = dateRange[0]?.endDate ? formatLocalDate(new Date(dateRange[0].endDate)) : null;

        const response = await getCashbackOverview(startDate, endDate, selectedLocations);

    const r = response || {};

const transformedData = [
  {
    name: t("return_metrics.bowls"),
    value: r.bowls || 0,
    color: colorMapping["Bowls"],
  },
  {
    name: t("return_metrics.bottles"),
    value: r.bottles || 0,
    color: colorMapping["Bottles"],
  },
];

setData(transformedData);
setTotalAmount(r.totalCashback || 0);
      } catch (err) {
        setError(t("sales_analytics.errorLoadingSalesData"));
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [selectedLocations, dateRange, applyClicked, i18n.language]);

  return (
    <div>
      <h3 className="subheading-sec-card" style={{ marginBottom: "0.2rem" }}>
        {t("return_metrics.cashbackOverview")}
      </h3>

      <div className="payment-discount-sec" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "20px", width: "100%" }}>
        <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>
          <PieChart width={240} height={240}>
            <Pie
              data={chartData}
              cx="50%"
              cy="50%"
              innerRadius={70}
              outerRadius={110}
              dataKey="value"
            >
              {chartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip formatter={(value) => `€ ${value.toFixed(2)}`} />
          </PieChart>
        </div>

        <div className="payment-discount-legend" style={{ flex: 1, paddingLeft: "20px", display: "flex", flexDirection: "column", gap: "12px" }}>
          {data.map((entry, index) => (
            <div key={index} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "17px" }}>
              <div style={{ display: "flex", alignItems: "center", flex: 1 }}>
                <span style={{ width: "10px", height: "10px", backgroundColor: entry.color, borderRadius: "50%", marginRight: "10px" }}></span>
                <span id="margin-bottom" className="popup-text" style={{ textAlign: "left", margin: "0px !important" }}>{entry.name}</span>
              </div>
              <span className="popup-text1" style={{ textAlign: "left", minWidth: "60px" }}>€ {entry.value.toFixed(2)}</span>
            </div>
          ))}

          <hr style={{ border: "none", borderTop: `1px solid ${dividerColor}`, margin: "4px 0 13px" }} />

          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <span id="margin-bottom" className="popup-text" style={{ textAlign: "left", margin: "0px", fontWeight: 600 }}>{t("return_metrics.totalCashback")}</span>
            <span className="popup-text1" style={{ textAlign: "left", minWidth: "60px", fontWeight: 600 }}>€ {totalAmount.toFixed(2)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CashbackOverviewChart;